import View from "../../../Account/Js/views/PartialAsyncView";
import components from "./components.js";
components.define("js-PartialAsync", View);